// extracted by mini-css-extract-plugin
module.exports = {"disabled":"CustomLink_disabled__vtpLm","link":"CustomLink_link__ErNU8"};